<template>
  <div class="login-page d-flex align-items-center justify-content-center">
    <div class="login-card p-5 shadow-lg rounded-4">
      <div class="text-center mb-4">
        <img src="@/assets/logo.png" alt="Logo" class="login-logo mb-3" />
        <h3 class="fw-bold title mb-1">Admin Panel</h3>
      </div>

      <div>
        <div class="form-group mb-3">
          <input v-model="email" type="email" class="form-control" placeholder="Email" />
        </div>

        <div class="form-group mb-3">
          <input v-model="password" type="password" class="form-control" placeholder="Password" />
        </div>

        <button
          @click="submitLogin" class="btn btn-login w-100 py-2 fw-semibold" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          Login
        </button>

        <p v-if="error" class="text-danger mt-3 text-center">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapGetters("admin", ["isLoading", "isAuthenticated"]),
    loading() {
      return this.isLoading;
    },
    error() {
      return this.$store.state.admin.error;
    }
  },
  methods: {
    ...mapActions("admin", ["login"]),
    async submitLogin() {
      await this.login({ email: this.email, password: this.password });
      if (this.isAuthenticated) {
        this.$router.push("/admin/products");
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.9)
    ),
}

.login-card {
  width: 100%;
  max-width: 420px;
  background-color: #fff;
  border: 1px solid #eee;
  animation: fadeInUp 0.6s ease;
}

.login-logo {
  width: 80px;
  height: auto;
}

.title {
  color: #c89d43;
  font-size: 1.6rem;
  letter-spacing: 0.3px;
}

.form-control {
  border: 1.5px solid #ddd;
  border-radius: 8px;
  padding: 10px 14px;
  transition: border-color 0.3s ease;
  font-size: 0.95rem;
}

.form-control:focus {
  border-color: #c89d43;
  box-shadow: 0 0 0 0.2rem rgba(200, 157, 67, 0.25);
}

.btn-login {
  background-color: #c89d43;
  border: none;
  color: #fff;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.btn-login:hover {
  background-color: #b0842d;
  transform: translateY(-1px);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
